import { type PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const KpiMetricGroup = ({ className = '', ...rest }: PropsWithChildren<Props>) => (
  <div
    {...rest}
    className={cn('grid gap-4.5 grid-cols-[repeat(auto-fit,minmax(200px,1fr))]', className)}
  />
);

export default KpiMetricGroup;
